import { render, staticRenderFns } from "./thirdpartyparameter-add.vue?vue&type=template&id=eb653d7c&"
import script from "./thirdpartyparameter-add.vue?vue&type=script&lang=ts&"
export * from "./thirdpartyparameter-add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports